import { DateRange, DatePickerPreset } from "@bebit/types";
import { DATE_PERIOD_FORMAT, isHighlightablePreset } from "@bebit/utils";
import { format, parse, isValid, endOfDay } from "date-fns";

export function convertPeriodToRouteQueryFormat(period: DateRange | DatePickerPreset): string {
  if (isPreset(period)) return isHighlightablePreset(period) ? period : "";
  return periodToQuery(period);
}

function isPreset(period: DateRange | DatePickerPreset): period is DatePickerPreset {
  return typeof period === "string";
}

function periodToQuery(period: DateRange): string {
  const startDate = format(period.start, DATE_PERIOD_FORMAT.url);
  const endDate = format(period.end, DATE_PERIOD_FORMAT.url);
  return `${startDate}_${endDate}`;
}

export function convertPeriodFromRouteQueryToPeriod(periodFromRouteQuery: string): DateRange | undefined {
  if (!isValidPeriodFromUrlFormat(periodFromRouteQuery)) return undefined;

  const [startDate, endDate] = periodFromRouteQuery.split("_");

  if (!startDate || !endDate) return undefined;
  if (startDate > endDate) return undefined;

  try {
    return {
      start: convertDateFromUrlFormatToDate(startDate),
      end: endOfDay(convertDateFromUrlFormatToDate(endDate)),
    };
  } catch (e) {
    return undefined;
  }
}

function isValidPeriodFromUrlFormat(periodFromUrl: string): boolean {
  const regex = /^[0-9]{8}_[0-9]{8}$/;
  return regex.test(periodFromUrl);
}

function convertDateFromUrlFormatToDate(dateFromUrl: string): Date {
  const date = parse(dateFromUrl, DATE_PERIOD_FORMAT.url, new Date());
  if (!isValid(date)) throw new Error("Invalid date from url");
  return date;
}
